var _defs, _line, _line2, _line3, _line4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        stroke: #ffc100;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.5,
    y1: 6,
    x2: 31.5,
    y2: 42
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.5,
    y1: 6,
    x2: 16.5,
    y2: 42
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6,
    y1: 16.5,
    x2: 42,
    y2: 16.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6,
    y1: 31.5,
    x2: 42,
    y2: 31.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridActive);
export default __webpack_public_path__ + "static/media/grid-active.8eec239c0df826c85ea8992cafe0f85d.svg";
export { ForwardRef as ReactComponent };